// Maps the `iconName` string returned by the backend agent-tool catalog
// (AgentTool.iconName() → @mui/icons-material export name) to the actual
// React component. Used by AgentConfigDrawer + AgentToolLoadout so new
// tools can appear with the correct icon without a frontend change —
// provided the icon is already imported here.
//
// To add a tool icon: import from @mui/icons-material, then add the
// entry to ICON_COMPONENT_MAP keyed by the export name string the
// backend sends.

import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import FunctionsOutlinedIcon from "@mui/icons-material/FunctionsOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import SearchIcon from "@mui/icons-material/Search";
import HttpIcon from "@mui/icons-material/Http";
import LanguageIcon from "@mui/icons-material/Language";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlaylistAddOutlinedIcon from "@mui/icons-material/PlaylistAddOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import DynamicFormOutlinedIcon from "@mui/icons-material/DynamicFormOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import ScheduleSendOutlinedIcon from "@mui/icons-material/ScheduleSendOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import EventRepeatOutlinedIcon from "@mui/icons-material/EventRepeatOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
// Phase 5a extended coverage — added 2026-04
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CompressOutlinedIcon from "@mui/icons-material/CompressOutlined";
import DataObjectOutlinedIcon from "@mui/icons-material/DataObjectOutlined";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import LinkOffOutlinedIcon from "@mui/icons-material/LinkOffOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import MoveDownOutlinedIcon from "@mui/icons-material/MoveDownOutlined";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import PublicOffOutlinedIcon from "@mui/icons-material/PublicOffOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export const ICON_COMPONENT_MAP = {
  SearchIcon,
  HttpIcon,
  LanguageIcon,
  EmailOutlinedIcon,
  SmartToyOutlinedIcon,
  ForumOutlinedIcon,
  SettingsSuggestOutlinedIcon,
  EditNoteOutlinedIcon,
  AccountTreeOutlinedIcon,
  HistoryOutlinedIcon,
  TableChartOutlinedIcon,
  ViewColumnOutlinedIcon,
  DriveFileRenameOutlineIcon,
  DeleteOutlineIcon,
  PlaylistAddOutlinedIcon,
  EditOutlinedIcon,
  StorageOutlinedIcon,
  DynamicFormOutlinedIcon,
  AssignmentOutlinedIcon,
  FactCheckOutlinedIcon,
  RateReviewOutlinedIcon,
  ListAltOutlinedIcon,
  UpdateOutlinedIcon,
  CodeOutlinedIcon,
  DescriptionOutlinedIcon,
  SendOutlinedIcon,
  ScheduleSendOutlinedIcon,
  EditCalendarOutlinedIcon,
  EventRepeatOutlinedIcon,
  CalendarTodayOutlinedIcon,
  EventNoteOutlinedIcon,
  EditCalendarIcon,
  ChatBubbleOutlineOutlinedIcon,
  BuildOutlinedIcon,
  FunctionsOutlinedIcon,
  CalculateOutlinedIcon,
  // Extended coverage
  AddBoxOutlinedIcon,
  AddCardOutlinedIcon,
  AutoAwesomeOutlinedIcon,
  CancelOutlinedIcon,
  CloudUploadOutlinedIcon,
  CompressOutlinedIcon,
  DataObjectOutlinedIcon,
  DeleteSweepOutlinedIcon,
  FileDownloadOutlinedIcon,
  FolderOpenOutlinedIcon,
  GroupsOutlinedIcon,
  HubOutlinedIcon,
  InsertDriveFileOutlinedIcon,
  LinkOffOutlinedIcon,
  LinkOutlinedIcon,
  MenuBookOutlinedIcon,
  MoveDownOutlinedIcon,
  NoteAltOutlinedIcon,
  PersonAddOutlinedIcon,
  PersonRemoveOutlinedIcon,
  PlayCircleOutlineIcon,
  PostAddOutlinedIcon,
  PsychologyOutlinedIcon,
  PublicOffOutlinedIcon,
  PublicOutlinedIcon,
  ReplayOutlinedIcon,
  RestartAltOutlinedIcon,
  SaveOutlinedIcon,
  SchemaOutlinedIcon,
  StopCircleOutlinedIcon,
  TableRowsOutlinedIcon,
  TimelineOutlinedIcon,
  TuneIcon,
  UploadFileOutlinedIcon,
  ViewQuiltOutlinedIcon,
  VisibilityOutlinedIcon,
};

export const DEFAULT_TOOL_ICON = BuildOutlinedIcon;

export function resolveToolIcon(iconName) {
  if (iconName && ICON_COMPONENT_MAP[iconName]) {
    return ICON_COMPONENT_MAP[iconName];
  }
  return DEFAULT_TOOL_ICON;
}
